module.exports = __webpack_public_path__ + "static/media/diy_goal_icon.f4a677ee.svg";